//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/simProviders/views/main/lan/es';
import createEditSimProvider from 'Modules/simProviders/views/.components/createEditSimProvider/lan/es';
import deleteSimProvider from 'Modules/simProviders/views/.components/deleteSimProvider/lan/es';

locales = { ...locales, ...main, ...createEditSimProvider, ...deleteSimProvider };

export default locales;